<p-toast></p-toast>

<!-- Skeleton loading state -->
<div class="preview-container" *ngIf="loading">
    <!-- Header skeleton -->
    <div class="preview-header">
        <div class="flex justify-content-between align-items-center">
            <div class="header-title">
                <i class="pi pi-file-text text-3xl"></i>
                <h1 class="ml-3">Detalles de Cotización del Arrendamiento</h1>
            </div>
            <div class="header-actions">
                <p-skeleton width="140px" height="40px"></p-skeleton>
            </div>
        </div>
    </div>

    <!-- Cards grid skeleton -->
    <div class="preview-content">
        <div class="cards-grid">
            <!-- Client info card skeleton -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-user"></i>
                    <h3>Información del Cliente</h3>
                    <div class="header-tags">
                        <p-skeleton width="80px" height="24px"></p-skeleton>
                    </div>
                </div>
                <div class="card-content">
                    <div class="client-basic-info">
                        <div class="client-avatar">
                            <p-skeleton shape="circle" size="60px"></p-skeleton>
                        </div>
                        <div class="client-details">
                            <p-skeleton width="180px" height="24px" class="mb-3"></p-skeleton>
                            <div class="client-meta">
                                <div class="meta-item">
                                    <p-skeleton width="200px" height="18px"></p-skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Assets info card skeleton -->
            <div class="info-card assets-enhanced-card">
                <div class="card-header">
                    <i class="pi pi-box"></i>
                    <h3>Información de Activos</h3>
                    <div class="header-tags">
                        <p-skeleton width="90px" height="24px"></p-skeleton>
                    </div>
                </div>
                <div class="card-content">
                    <div class="assets-financial-container">
                        <div class="assets-list-section">
                            <p-skeleton width="180px" height="18px" class="mb-3"></p-skeleton>
                            <p-skeleton width="120px" height="16px" class="mb-2"></p-skeleton>
                        </div>
                        <div class="financial-summary-section">
                            <p-skeleton width="140px" height="18px" class="mb-3"></p-skeleton>
                            <div class="financial-summary-card">
                                <div class="financial-breakdown">
                                    <div class="breakdown-row">
                                        <p-skeleton width="100px" height="16px"></p-skeleton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Financial config card skeleton -->
        <div class="info-card wide-card">
            <div class="card-header">
                <i class="pi pi-calculator"></i>
                <h3>Detalles Financieros</h3>
            </div>
            <div class="card-content">
                <div class="financial-grid">
                    <div class="financial-item" *ngFor="let item of [1,2,3,4,5,6]">
                        <p-skeleton width="140px" height="14px" class="mb-2"></p-skeleton>
                        <p-skeleton width="80px" height="20px"></p-skeleton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ===== VISTA DE COTIZACIÓN DEFINITIVA (Post-Primer Pago) ===== -->
<div class="preview-container" *ngIf="calculatedQuote && !loading">
    <!-- Header with client info and download button -->
    <div class="preview-header" *ngIf="hasClientInfo()">
        <div class="flex justify-content-between align-items-center">
            <div class="header-title">
                <i class="pi pi-check-circle text-3xl text-green-600"></i>
                <h1 class="ml-3">Cotización Aprobada</h1>
                <p-tag value="Activa" severity="success" icon="pi pi-check" class="ml-3"></p-tag>
            </div>
            <div class="header-actions">
                <button 
                    pButton 
                    type="button" 
                    icon="fa-regular fa-file-pdf" 
                    class="pdf-button p-button-outlined"
                    (click)="downloadPDF()"
                    pTooltip="Descargar PDF"
                    tooltipPosition="top">
                </button>
            </div>
        </div>
    </div>

    <!-- Content cards -->
    <div class="preview-content">
        <!-- First row: Client and Assets info only -->
        <div class="cards-grid">
            <!-- Client Information Card -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-user text-indigo-600"></i>
                    <h3>Información del Cliente</h3>
                    <div class="header-tags">
                        <p-tag 
                            *ngIf="calculatedQuote.client" 
                            value="Definitivo" 
                            severity="success"
                            class="client-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!calculatedQuote.client" 
                            value="Provisional" 
                            severity="warning"
                            class="client-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Client Basic Info -->
                    <div class="client-basic-info">
                        <div class="client-avatar">
                            <i class="pi pi-user text-4xl text-indigo-500"></i>
                        </div>
                        <div class="client-details">
                            <h4 class="client-name">{{ getClientName() }}</h4>
                            <div class="client-meta" *ngIf="calculatedQuote.client || data.client">
                                <div class="meta-item" *ngIf="calculatedQuote.client?.email || data.client?.email">
                                    <i class="pi pi-envelope text-gray-500"></i>
                                    <span class="meta-value">{{ calculatedQuote.client?.email || data.client?.email }}</span>
                                </div>
                                <div class="meta-item" *ngIf="calculatedQuote.client?.phone || data.client?.phone">
                                    <i class="pi pi-phone text-gray-500"></i>
                                    <span class="meta-value">{{ calculatedQuote.client?.phone || data.client?.phone }}</span>
                                </div>
                                <div class="meta-item" *ngIf="calculatedQuote.client?._id || data.client?._id">
                                    <i class="pi pi-id-card text-gray-500"></i>
                                    <span class="meta-value client-id">ID: {{ (calculatedQuote.client?._id || data.client?._id)?.slice(-8) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Quote Timeline -->
                    <div class="quote-timeline">
                        <div class="timeline-header">
                            <i class="pi pi-clock text-blue-600"></i>
                            <span class="timeline-title">Historial de Cotización</span>
                        </div>
                        <div class="timeline-items">
                            <div class="timeline-item created">
                                <div class="timeline-marker created-marker">
                                    <i class="pi pi-plus-circle"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Creada</span>
                                    <span class="timeline-date">{{ calculatedQuote.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                </div>
                            </div>
                            <div class="timeline-item updated" *ngIf="calculatedQuote.updatedAt !== calculatedQuote.createdAt">
                                <div class="timeline-marker updated-marker">
                                    <i class="pi pi-pencil"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Actualizada</span>
                                    <span class="timeline-date">{{ calculatedQuote.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Assets Information Card - Enhanced and Double Width -->
            <div class="info-card assets-enhanced-card">
                <div class="card-header">
                    <i class="pi pi-box text-blue-600"></i>
                    <h3>Información de Activos</h3>
                    <div class="header-tags">
                        <p-tag 
                            [value]="getTotalAssetsCount() + ' activo(s)'" 
                            severity="info" 
                            class="count-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="hasDefinitiveAssets()" 
                            value="Definitivos" 
                            severity="success"
                            class="assets-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!hasDefinitiveAssets()" 
                            value="Provisional" 
                            severity="warning"
                            class="assets-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Provisional Assets View -->
                    <div *ngIf="!hasDefinitiveAssets()" class="provisional-assets">
                        <div class="provisional-banner">
                            <div class="provisional-icon">
                                <i class="pi pi-exclamation-triangle text-4xl text-orange-500"></i>
                            </div>
                            <div class="provisional-info">
                                <h4 class="provisional-title">{{ calculatedQuote.assetsNames || 'Activo no especificado' }}</h4>
                                <p class="provisional-subtitle">Información provisional pendiente de confirmar</p>
                                <div class="provisional-value-display">
                                    <span class="value-label">Valor estimado</span>
                                    <span class="value-amount">{{ calculatedQuote.assetsValue?.total | currency:'MXN':'symbol':'1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Definitive Assets View - Horizontal Layout -->
                    <div *ngIf="hasDefinitiveAssets()" class="definitive-assets-horizontal">
                        <!-- Assets Summary Bar - Horizontal with Better Spacing -->
                        <div class="assets-summary-bar-horizontal">
                            <div class="summary-stat">
                                <i class="pi pi-tags text-blue-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Categorías</span>
                                    <span class="stat-value">{{ getAssetsCategorySummary() || 'No especificada' }}</span>
                                </div>
                            </div>
                            <div class="summary-stat">
                                <i class="pi pi-calendar text-green-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Registrados</span>
                                    <span class="stat-value">{{ formatDate(getDefinitiveAssets()[0]?.createdAt) || 'Fecha no disponible' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Assets and Financial Layout - Two Column with Better Structure -->
                        <div class="assets-financial-container">
                            <!-- Left Column: Assets List -->
                            <div class="assets-list-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-list text-blue-600"></i>
                                        <h4>Activos Incluidos</h4>
                                    </div>
                                </div>
                                
                                <!-- Detailed Assets List - Improved Horizontal Cards -->
                                <div *ngIf="hasDetailedAssets()" class="assets-list-container">
                                    <div class="asset-card-improved" *ngFor="let asset of getDefinitiveAssets(); let i = index; trackBy: trackByAssetId">
                                        <!-- Asset Header with Clear Hierarchy -->
                                        <div class="asset-header-section">
                                            <div class="asset-identity">
                                                <div class="asset-number">{{ i + 1 }}</div>
                                                <div class="asset-name-section">
                                                    <h5 class="asset-name">{{ asset.name || 'Sin nombre' }}</h5>
                                                    <div class="asset-status-badges">
                                                        <span class="category-badge" *ngIf="asset.category?.name || asset.category">
                                                            {{ asset.category?.name || asset.category }}
                                                        </span>
                                                        <span class="status-badge" [ngClass]="getAssetStatusClass(asset.status)" *ngIf="asset.status">
                                                            {{ asset.status }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="asset-value-section">
                                                <span class="asset-total-value">{{ asset.acquisition?.total || asset.totalWorth || asset.total || 0 | currency:'MXN':'symbol':'1.2-2' }}</span>
                                            </div>
                                        </div>

                                        <!-- Asset Details Section - Improved with Chips -->
                                        <div class="asset-details-section" *ngIf="asset.brand || asset.model || asset.year || asset.serialNumber">
                                            <div class="details-grid">
                                                <div class="detail-chip" *ngIf="asset.brand">
                                                    <i class="pi pi-tag chip-icon text-blue-600"></i>
                                                    <span class="chip-text">{{ asset.brand }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.model">
                                                    <i class="pi pi-bookmark chip-icon text-purple-600"></i>
                                                    <span class="chip-text">{{ asset.model }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.year">
                                                    <i class="pi pi-calendar chip-icon text-green-600"></i>
                                                    <span class="chip-text">{{ asset.year }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.serialNumber">
                                                    <i class="pi pi-hashtag chip-icon text-orange-600"></i>
                                                    <span class="chip-text">S/N: {{ asset.serialNumber }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Simple Assets List - if no detailed info -->
                                <div *ngIf="!hasDetailedAssets()" class="simple-assets-container">
                                    <div class="simple-asset-item" *ngFor="let asset of getDefinitiveAssets()">
                                        <i class="pi pi-box text-blue-600"></i>
                                        <span>{{ asset.name || calculatedQuote.assetsNames || 'Activo sin nombre' }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Column: Financial Summary -->
                            <div class="financial-summary-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-dollar text-green-600"></i>
                                        <h4>Resumen Financiero</h4>
                                    </div>
                                </div>
                                
                                <div class="financial-summary-card">
                                    <div class="financial-breakdown">
                                        <div class="breakdown-row subtotal-row">
                                            <span class="breakdown-label">Subtotal</span>
                                            <span class="breakdown-value">{{ calculatedQuote.assetsValue?.amount | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                        <div class="breakdown-row iva-row">
                                            <span class="breakdown-label">IVA (16%)</span>
                                            <span class="breakdown-value">{{ calculatedQuote.assetsValue?.iva | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                        <div class="breakdown-separator"></div>
                                        <div class="breakdown-row total-row">
                                            <span class="breakdown-label">Total</span>
                                            <span class="breakdown-value total-amount">{{ calculatedQuote.assetsValue?.total | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Financial Details Card - Full Width --> 
        <div class="info-card wide-card">
            <div class="card-header">
                <i class="pi pi-calculator text-green-600"></i>
                <h3>Detalles Financieros</h3>
            </div>
            <div class="card-content">
                <div class="financial-grid">
                    <div class="financial-item">
                        <span class="label">Anticipo:</span>
                        <span class="value financial-value">{{ calculatedQuote.advance?.rate | number: '1.2-2' }}%</span>
                    </div>

                    <div class="financial-item">
                        <span class="label">Comisión de apertura:</span>
                        <span class="value financial-value">{{ calculatedQuote.openingCommission?.rate | number: '1.2-2' }}%</span>
                    </div>

                    <div class="financial-item">
                        <span class="label">Monto a financiar:</span>
                        <span class="value financial-value">{{ calculatedQuote.amountToFinance | currency }}</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Tasa de interés:</span>
                        <span class="value financial-value">{{ calculatedQuote.interestRate | number: '1.2-2' }}%</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Rentas anticipadas:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData?.advancedRents?.number || 0 }} meses</span>
                    </div>
                    
                    <div class="financial-item">
                        <span class="label">Provisión PE:</span>
                        <span class="value financial-value">{{ calculatedQuote.provisionPe | number: '1.2-2' }}%</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Term Data (Selected Term with calculations) -->
        <div class="info-card wide-card term-selected-card" *ngIf="calculatedQuote.termData">
            <div class="card-header">
                <i class="pi pi-check-circle text-green-600"></i>
                <h3>Término Seleccionado - {{ calculatedQuote.termData.term }} meses</h3>
                <div class="header-tags">
                    <p-tag value="Aprobado" severity="success"></p-tag>
                </div>
            </div>
            <div class="card-content">
                <!-- Key Financial Metrics -->
                <div class="financial-grid">
                    <div class="financial-item">
                        <span class="label">TIR:</span>
                        <span class="value financial-value highlight">{{ calculatedQuote.termData.irr | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">TIR Ajustada:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.irrAdjusted | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Tasa Comercial:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.commercialRate | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Factor de Arrendamiento:</span>
                        <span class="value financial-value">{{ calculatedQuote.termData.leaseFactor | number: '1.4-4' }}</span>
                    </div>
                </div>

                <!-- Desgloses por plazo (Cartera / Renta / Primer Pago / Residual + Accesorios) -->
                <ng-container *ngTemplateOutlet="termBreakdown; context: { quote: calculatedQuote, term: calculatedQuote.termData }"></ng-container>

                <!-- Total Payment Highlight -->
                <div class="total-lease-payment">
                    <div class="total-payment-card">
                        <div class="total-payment-header">
                            <i class="pi pi-money-bill text-4xl text-green-600"></i>
                            <h4>Pago Total del Arrendamiento</h4>
                        </div>
                        <div class="total-payment-amount">
                            {{ calculatedQuote.termData.totalLeasePayment | currency }}
                        </div>
                        <div class="total-payment-note" *ngIf="calculatedQuote.termData?.taxSavingsIncomeDeductibility">
                            <i class="pi pi-info-circle text-blue-600"></i>
                            <span>Ahorro Fiscal: {{ calculatedQuote.termData.taxSavingsIncomeDeductibility | number: '1.2-2' }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Amortization Table Card -->
        <div class="info-card wide-card" *ngIf="getAmortizationPeriods().length > 0">
            <div class="card-header">
                <i class="pi pi-table text-purple-600"></i>
                <h3>Tabla de Amortización</h3>
                <div class="header-tags">
                    <p-tag [value]="getAmortizationPeriods().length + ' períodos'" severity="info"></p-tag>
                </div>
            </div>
            <div class="card-content">
                <div class="table-container">
                    <p-table [value]="getAmortizationPeriods()" [scrollable]="true" scrollHeight="400px" styleClass="p-datatable-sm amortization-table">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="text-center">#</th>
                                <th class="text-center">Fecha</th>
                                <th class="text-center">Renta</th>
                                <th class="text-center">Capital</th>
                                <th class="text-center">Interés</th>
                                <th class="text-center">Accesorios</th>
                                <th class="text-center">Pago Total</th>
                                <th class="text-center">Saldo Pendiente</th>
                                <th class="text-center">Estado</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-period>
                            <tr>
                                <td class="text-center">{{ period.period }}</td>
                                <td class="text-center">{{ period.date | date:'dd/MM/yyyy' }}</td>
                                <td class="text-right">{{ period.rent | currency }}</td>
                                <td class="text-right">{{ period.capital | currency }}</td>
                                <td class="text-right">{{ period.interest | currency }}</td>
                                <td class="text-right">{{ period.accessoriesAmount | currency }}</td>
                                <td class="text-right font-bold">{{ period.payment | currency }}</td>
                                <td class="text-right">{{ period.outstandingBalance | currency }}</td>
                                <td class="text-center">
                                    <p-tag 
                                        [value]="period.status === 'PENDING' ? 'Pendiente' : period.status === 'PAID' ? 'Pagado' : period.status === 'OVERDUE' ? 'Vencido' : 'Anticipado'" 
                                        [severity]="period.status === 'PENDING' ? 'warning' : period.status === 'PAID' ? 'success' : period.status === 'OVERDUE' ? 'danger' : 'info'">
                                    </p-tag>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

        <!-- Accesorios: el desglose (contado/financiado) ahora vive en la plantilla #termBreakdown -->
    </div>
</div>

<!-- No data message -->
<div *ngIf="!calculatedQuote && !loading && !hasQuotationParameters()" class="no-data-container">
    <div class="no-data-card">
        <i class="pi pi-exclamation-triangle text-6xl text-orange-400"></i>
        <h3>Cotización no encontrada</h3>
        <p>No hay datos de cotización disponibles para este arrendamiento</p>
    </div>
</div>

<!-- ===== VISTA DE QUOTATION PARAMETERS (Pre-Primer Pago) ===== -->
<div class="preview-container" *ngIf="!hasCompleteQuoteData() && hasQuotationParameters() && !loading">
    <!-- Header con badge de advertencia -->
    <div class="preview-header">
        <div class="flex justify-content-between align-items-center">
            <div class="header-title">
                <i class="pi pi-file-edit text-3xl text-orange-600"></i>
                <h1 class="ml-3">Parámetros de Cotización</h1>
                <p-tag value="Pendiente de Activación" severity="warning" icon="pi pi-clock" class="ml-3"></p-tag>
            </div>
            <div class="header-actions">
                <button 
                    pButton 
                    type="button" 
                    label="Editar" 
                    icon="pi pi-pencil" 
                    class="p-button-outlined mr-2"
                    (click)="openEditModal()"
                    [disabled]="!canEditParameters()"
                    pTooltip="Editar parámetros de cotización"
                    tooltipPosition="top">
                </button>
                <button 
                    pButton 
                    type="button" 
                    icon="fa-regular fa-file-pdf" 
                    class="pdf-button p-button-outlined"
                    (click)="downloadPDF()"
                    pTooltip="Descargar PDF"
                    tooltipPosition="top">
                </button>
            </div>
        </div>
    </div>

    <!-- Content cards -->
    <div class="preview-content">
        <!-- First row: Client and Assets info -->
        <div class="cards-grid">
            <!-- Client Information Card -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-user text-indigo-600"></i>
                    <h3>Información del Cliente</h3>
                    <div class="header-tags">
                        <p-tag 
                            *ngIf="hasParametersDefinitiveClient()" 
                            value="Definitivo" 
                            severity="success"
                            class="client-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!hasParametersDefinitiveClient()" 
                            value="Provisional" 
                            severity="warning"
                            class="client-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Client Basic Info -->
                    <div class="client-basic-info">
                        <div class="client-avatar">
                            <i class="pi pi-user text-4xl text-indigo-500"></i>
                        </div>
                        <div class="client-details">
                            <h4 class="client-name">{{ getParametersClientName() }}</h4>
                            <div class="client-meta" *ngIf="hasParametersDefinitiveClient() && data.quotationParameters.client">
                                <div class="meta-item" *ngIf="data.quotationParameters.client.email">
                                    <i class="pi pi-envelope text-gray-500"></i>
                                    <span class="meta-value">{{ data.quotationParameters.client.email }}</span>
                                </div>
                                <div class="meta-item" *ngIf="data.quotationParameters.client.phone">
                                    <i class="pi pi-phone text-gray-500"></i>
                                    <span class="meta-value">{{ data.quotationParameters.client.phone }}</span>
                                </div>
                                <div class="meta-item" *ngIf="data.quotationParameters.client._id">
                                    <i class="pi pi-id-card text-gray-500"></i>
                                    <span class="meta-value client-id">ID: {{ data.quotationParameters.client._id.slice(-8) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Quote Timeline -->
                    <div class="quote-timeline">
                        <div class="timeline-header">
                            <i class="pi pi-clock text-blue-600"></i>
                            <span class="timeline-title">Historial de Parámetros</span>
                        </div>
                        <div class="timeline-items">
                            <div class="timeline-item created">
                                <div class="timeline-marker created-marker">
                                    <i class="pi pi-plus-circle"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Creados</span>
                                    <span class="timeline-date">{{ formatDate(data.quotationParameters.createdAt) }}</span>
                                </div>
                            </div>
                            <div class="timeline-item updated" *ngIf="data.quotationParameters.updatedAt !== data.quotationParameters.createdAt">
                                <div class="timeline-marker updated-marker">
                                    <i class="pi pi-pencil"></i>
                                </div>
                                <div class="timeline-content">
                                    <span class="timeline-label">Actualizados</span>
                                    <span class="timeline-date">{{ formatDate(data.quotationParameters.updatedAt) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Assets Information Card - Enhanced and Double Width -->
            <div class="info-card assets-enhanced-card">
                <div class="card-header">
                    <i class="pi pi-box text-blue-600"></i>
                    <h3>Información de Activos</h3>
                    <div class="header-tags">
                        <p-tag 
                            [value]="getParametersTotalAssetsCount() + ' activo(s)'" 
                            severity="info" 
                            class="count-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="hasParametersDefinitiveAssets()" 
                            value="Definitivos" 
                            severity="success"
                            class="assets-tag">
                        </p-tag>
                        <p-tag 
                            *ngIf="!hasParametersDefinitiveAssets()" 
                            value="Provisional" 
                            severity="warning"
                            class="assets-tag">
                        </p-tag>
                    </div>
                </div>
                <div class="card-content">
                    <!-- Provisional Assets View -->
                    <div *ngIf="!hasParametersDefinitiveAssets()" class="provisional-assets">
                        <div class="provisional-banner">
                            <div class="provisional-icon">
                                <i class="pi pi-exclamation-triangle text-4xl text-orange-500"></i>
                            </div>
                            <div class="provisional-info">
                                <h4 class="provisional-title">{{ data.quotationParameters.provitionalAsset || 'Activo no especificado' }}</h4>
                                <p class="provisional-subtitle">Información provisional pendiente de confirmar</p>
                                <div class="provisional-value-display">
                                    <span class="value-label">Valor estimado</span>
                                    <span class="value-amount">{{ data.quotationParameters.provitionalValue | currency:'MXN':'symbol':'1.2-2' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Definitive Assets View - Horizontal Layout -->
                    <div *ngIf="hasParametersDefinitiveAssets()" class="definitive-assets-horizontal">
                        <!-- Assets Summary Bar -->
                        <div class="assets-summary-bar-horizontal">
                            <div class="summary-stat">
                                <i class="pi pi-tags text-blue-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Categorías</span>
                                    <span class="stat-value">{{ getParametersAssetsCategorySummary() || 'No especificada' }}</span>
                                </div>
                            </div>
                            <div class="summary-stat">
                                <i class="pi pi-calendar text-green-600"></i>
                                <div class="stat-content">
                                    <span class="stat-label">Registrados</span>
                                    <span class="stat-value">{{ formatDate(getParametersDefinitiveAssets()[0]?.createdAt) || 'Fecha no disponible' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Assets and Financial Layout -->
                        <div class="assets-financial-container">
                            <!-- Left Column: Assets List -->
                            <div class="assets-list-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-list text-blue-600"></i>
                                        <h4>Listado de Activos</h4>
                                    </div>
                                </div>
                                
                                <!-- Detailed Assets List -->
                                <div *ngIf="hasParametersDetailedAssets()" class="assets-list-container">
                                    <div class="asset-card-improved" *ngFor="let asset of getParametersDefinitiveAssets(); let i = index" [attr.data-index]="i">
                                        <!-- Asset Header -->
                                        <div class="asset-header-section">
                                            <div class="asset-identity">
                                                <div class="asset-number">{{ i + 1 }}</div>
                                                <div class="asset-name-section">
                                                    <h5 class="asset-name">{{ asset.name || 'Activo sin nombre' }}</h5>
                                                    <div class="asset-status-badges">
                                                        <span class="category-badge" *ngIf="asset.category?.name || asset.category">
                                                            {{ asset.category?.name || asset.category }}
                                                        </span>
                                                        <span class="status-badge" [ngClass]="getAssetStatusClass(asset.status)" *ngIf="asset.status">
                                                            {{ asset.status }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="asset-value-section">
                                                <span class="asset-total-value">{{ asset.acquisition?.total || asset.totalWorth || asset.total || 0 | currency:'MXN':'symbol':'1.2-2' }}</span>
                                            </div>
                                        </div>

                                        <!-- Asset Details Section -->
                                        <div class="asset-details-section" *ngIf="asset.brand || asset.model || asset.year || asset.serialNumber">
                                            <div class="details-grid">
                                                <div class="detail-chip" *ngIf="asset.brand">
                                                    <i class="pi pi-tag chip-icon text-blue-600"></i>
                                                    <span class="chip-text">{{ asset.brand }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.model">
                                                    <i class="pi pi-bookmark chip-icon text-purple-600"></i>
                                                    <span class="chip-text">{{ asset.model }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.year">
                                                    <i class="pi pi-calendar chip-icon text-green-600"></i>
                                                    <span class="chip-text">{{ asset.year }}</span>
                                                </div>
                                                <div class="detail-chip" *ngIf="asset.serialNumber">
                                                    <i class="pi pi-hashtag chip-icon text-orange-600"></i>
                                                    <span class="chip-text">S/N: {{ asset.serialNumber }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Simple Assets List -->
                                <div *ngIf="!hasParametersDetailedAssets()" class="simple-assets-container">
                                    <div class="simple-asset-item" *ngFor="let asset of getParametersDefinitiveAssets(); let i = index">
                                        <i class="pi pi-box text-blue-600"></i>
                                        <span class="simple-asset-name">Activo {{ i + 1 }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Column: Financial Summary -->
                            <div class="financial-summary-section">
                                <div class="section-header">
                                    <div class="section-title">
                                        <i class="pi pi-calculator text-green-600"></i>
                                        <h4>Resumen Financiero</h4>
                                    </div>
                                </div>
                                
                                <div class="financial-summary-card">
                                    <div class="financial-breakdown">
                                        <div class="breakdown-row subtotal-row">
                                            <span class="breakdown-label">Subtotal</span>
                                            <span class="breakdown-value">{{ (data.quotationParameters.assetsValue?.amount ?? data.quotationParameters.provitionalValue ?? 0) | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                        <div class="breakdown-row iva-row">
                                            <span class="breakdown-label">IVA (16%)</span>
                                            <span class="breakdown-value">{{ (data.quotationParameters.assetsValue?.iva ?? (data.quotationParameters.provitionalValue ?? 0) * 0.16) | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                        <div class="breakdown-separator"></div>
                                        <div class="breakdown-row total-row">
                                            <span class="breakdown-label">Total</span>
                                            <span class="breakdown-value total-amount">{{ (data.quotationParameters.assetsValue?.total ?? (data.quotationParameters.provitionalValue ?? 0) * 1.16) | currency:'MXN':'symbol':'1.2-2' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Financial Configuration Card - Full Width -->
        <div class="info-card wide-card">
            <div class="card-header">
                <i class="pi pi-calculator text-green-600"></i>
                <h3>Configuración Financiera</h3>
            </div>
            <div class="card-content">
                <div class="financial-grid">
                    <div class="financial-item">
                        <span class="label">Anticipo:</span>
                        <div class="value-row">
                            <span class="value financial-value">{{ data.quotationParameters.advance | number: '1.2-2' }}%</span>
                            <span class="value-peso" *ngIf="calculatedParams?.advance">{{ calculatedParams.advance.amount | currency }}</span>
                        </div>
                    </div>
                    <div class="financial-item">
                        <span class="label">Tasa de interés:</span>
                        <span class="value financial-value">{{ data.quotationParameters.interestRate | number: '1.2-2' }}%</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Comisión de apertura:</span>
                        <div class="value-row">
                            <span class="value financial-value">{{ data.quotationParameters.openingCommission | number: '1.2-2' }}%</span>
                            <span class="value-peso" *ngIf="calculatedParams?.openingCommission">{{ calculatedParams.openingCommission.amount | currency }}</span>
                        </div>
                    </div>
                    <div class="financial-item">
                        <span class="label">Rentas anticipadas:</span>
                        <span class="value financial-value">{{ data.quotationParameters.advancedRents }} meses</span>
                    </div>
                    <div class="financial-item">
                        <span class="label">Gastos de ratificación:</span>
                        <span class="value financial-value">{{ data.quotationParameters.ratificationExpenses | currency }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Terms and Accessories Row -->
        <div class="cards-grid">
            <!-- Terms Table Card -->
            <div class="info-card">
                <div class="card-header">
                    <i class="pi pi-list text-purple-600"></i>
                    <h3>Términos Configurados</h3>
                    <p-tag [value]="data.quotationParameters.terms.length + ' término(s)'" severity="info" class="ml-auto"></p-tag>
                </div>
                <div class="card-content">
                    <div class="terms-table">
                        <div class="table-header">
                            <span class="header-cell">Término (meses)</span>
                            <span class="header-cell">Valor Residual (%)</span>
                        </div>
                        <div class="table-body">
                            <div class="table-row" *ngFor="let term of data.quotationParameters.terms">
                                <span class="body-cell">{{ term.term }}</span>
                                <span class="body-cell">{{ term.residuary | number: '1.2-2' }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Accessories Card -->
            <div class="info-card" *ngIf="getParametersAccessoriesCount() > 0">
                <div class="card-header">
                    <i class="pi pi-plus-circle text-cyan-600"></i>
                    <h3>Accesorios</h3>
                    <p-tag [value]="getParametersAccessoriesCount() + ' accesorio(s)'" severity="info" class="ml-auto"></p-tag>
                </div>
                <div class="card-content">
                    <!-- Regular Accessories -->
                    <div *ngIf="getParametersRegularAccessories().length > 0" class="accessories-section">
                        <h4 class="section-subtitle">Accesorios Regulares</h4>
                        <div class="accessories-list">
                            <div class="accessory-item" *ngFor="let accessory of getParametersRegularAccessories()">
                                <div class="accessory-header">
                                    <span class="accessory-name">{{ accessory.name }}</span>
                                    <p-tag 
                                        [value]="accessory.paymentType" 
                                        [severity]="accessory.paymentType === 'Contado' ? 'success' : 'info'">
                                    </p-tag>
                                </div>
                                <div class="accessory-details">
                                    <div class="detail-item">
                                        <i class="pi pi-dollar"></i>
                                        <span>{{ accessory.amount | currency:'MXN':'symbol':'1.2-2' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Insurance Accessories -->
                    <div *ngIf="getParametersInsuranceAccessories().length > 0" class="accessories-section">
                        <h4 class="section-subtitle">Seguros</h4>
                        <div class="accessories-list">
                            <div class="accessory-item insurance-item" *ngFor="let insurance of getParametersInsuranceAccessories()">
                                <div class="accessory-header">
                                    <span class="accessory-name">{{ insurance.name }}</span>
                                    <p-tag value="Seguro" severity="warning"></p-tag>
                                </div>
                                <div class="accessory-details">
                                    <div class="detail-item">
                                        <i class="pi pi-dollar"></i>
                                        <span>{{ insurance.amount | currency:'MXN':'symbol':'1.2-2' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Accessories Card -->
            <div class="info-card empty-card" *ngIf="getParametersAccessoriesCount() === 0">
                <div class="card-header">
                    <i class="pi pi-plus-circle text-gray-400"></i>
                    <h3>Accesorios</h3>
                </div>
                <div class="card-content">
                    <div class="empty-state">
                        <i class="pi pi-inbox text-6xl text-gray-300"></i>
                        <p class="empty-message">No se han configurado accesorios para esta cotización</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Desglose de la cotización calculado al vuelo, por plazo (selector) -->
        <div class="info-card wide-card" *ngIf="calculatedParams?.selectedTerms?.length">
            <div class="card-header">
                <i class="pi pi-calculator text-green-600"></i>
                <h3>Desglose de la Cotización</h3>
                <p-tag [value]="paramTermOptions.length + ' plazo(s)'" severity="info" class="ml-auto"></p-tag>
            </div>
            <div class="card-content">
                <div class="term-selector-bar">
                    <span class="term-selector-label">Plazo a visualizar:</span>
                    <div class="term-selector">
                        <button *ngFor="let opt of paramTermOptions" type="button"
                            class="term-chip" [class.active]="selectedParamTermIndex === opt.value"
                            (click)="selectedParamTermIndex = opt.value">
                            {{ opt.label }}
                        </button>
                    </div>
                </div>
                <ng-container *ngTemplateOutlet="termBreakdown; context: { quote: calculatedParams, term: selectedParamTerm, showAccessories: false }"></ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Modal de edición de parámetros de cotización -->
<p-dialog
    [(visible)]="showEditModal"
    header="Editar Parámetros de Cotización"
    styleClass="quote-edit-dialog"
    [style]="{width: '95vw', height: '90vh'}"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="onFormCancel()">
    
    <ng-template pTemplate="content">
        <div class="modal-content-wrapper">
            <app-quote-form></app-quote-form>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button 
            pButton 
            pRipple 
            label="Cancelar" 
            icon="pi pi-times" 
            class="p-button-text p-button-danger" 
            (click)="onFormCancel()">
        </button>
        <button 
            pButton 
            pRipple 
            label="Guardar" 
            icon="pi pi-check" 
            class="p-button-outlined p-button-success" 
            (click)="saveForm()" 
            [loading]="editingParameters"
            [disabled]="!quoteParametersService.entity.valid">
        </button>
        <button 
            pButton 
            pRipple 
            label="Calcular" 
            icon="fa-solid fa-calculator" 
            class="p-button-primary" 
            [loading]="editingParameters" 
            (click)="getAmounts()" 
            [disabled]="!quoteParametersService.entity.valid">
        </button>
    </ng-template>
    
</p-dialog>

<p-dialog
    [(visible)]="showPdfOptionsDialog"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    styleClass="pdf-confirm-dialog"
    header="Opciones de PDF">
    <div class="flex align-items-center gap-3">
        <i class="pi pi-file-pdf" style="font-size: 1.5rem"></i>
        <span>¿Deseas incluir el valor residual (opción de compra) en la cotización PDF?</span>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between w-full">
            <button pButton type="button" label="Cancelar" icon="pi pi-times"
                class="p-button-outlined p-button-danger"
                (click)="closePdfDialog()"></button>
            <div class="flex gap-2">
                <button pButton type="button" label="No, omitir" icon="pi pi-minus-circle"
                    class="p-button-outlined"
                    (click)="generatePdf(false)"></button>
                <button pButton type="button" label="Sí, incluir" icon="pi pi-check-circle"
                    class="p-button-primary"
                    (click)="generatePdf(true)"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- ===== Plantilla compartida de desgloses por plazo (vista aprobada y vista parámetros) ===== -->
<!-- Recibe: quote (montos top-level: advance, openingCommission, ratificationExpenses) y term  -->
<!-- (rent/residuary/downPayment/advancedRents/accessoriesDetail). showAccessories=false oculta  -->
<!-- el desglose de accesorios cuando la vista ya lista los accesorios por otra vía.             -->
<ng-template #termBreakdown let-quote="quote" let-term="term" let-showAccessories="showAccessories">
    <div class="payment-details-grid" *ngIf="term">
        <!-- #2 Valor Cartera (rentas × plazo) -->
        <div class="payment-detail-card">
            <div class="payment-header">
                <i class="pi pi-briefcase text-orange-600"></i>
                <h4>Valor Cartera ({{ term.term }} rentas)</h4>
            </div>
            <div class="payment-breakdown">
                <div class="breakdown-row">
                    <span class="breakdown-label">Renta mensual</span>
                    <span class="breakdown-value">{{ term.rent.total | currency }}</span>
                </div>
                <div class="breakdown-row">
                    <span class="breakdown-label">Subtotal</span>
                    <span class="breakdown-value">{{ getCartera(term).subtotal | currency }}</span>
                </div>
                <div class="breakdown-row">
                    <span class="breakdown-label">IVA</span>
                    <span class="breakdown-value">{{ getCartera(term).iva | currency }}</span>
                </div>
                <div class="breakdown-separator"></div>
                <div class="breakdown-row total-row">
                    <span class="breakdown-label">Total cartera</span>
                    <span class="breakdown-value total-amount">{{ getCartera(term).total | currency }}</span>
                </div>
            </div>
        </div>

        <!-- #3 Valor de Renta (mensual) -->
        <div class="payment-detail-card">
            <div class="payment-header">
                <i class="pi pi-calendar text-blue-600"></i>
                <h4>Renta Mensual</h4>
            </div>
            <div class="payment-breakdown" *ngIf="rentBreakdown(term.rent) as rent">
                <div class="breakdown-row">
                    <span class="breakdown-label">Renta</span>
                    <span class="breakdown-value">{{ rent.rent | currency }}</span>
                </div>
                <ng-container *ngIf="rent.hasAccessories">
                    <div class="breakdown-row">
                        <span class="breakdown-label">Accesorios</span>
                        <span class="breakdown-value">{{ rent.accessories | currency }}</span>
                    </div>
                    <div class="breakdown-row">
                        <span class="breakdown-label">Subtotal (sin IVA)</span>
                        <span class="breakdown-value">{{ rent.subtotal | currency }}</span>
                    </div>
                </ng-container>
                <div class="breakdown-row">
                    <span class="breakdown-label">IVA</span>
                    <span class="breakdown-value">{{ rent.iva | currency }}</span>
                </div>
                <div class="breakdown-separator"></div>
                <div class="breakdown-row total-row">
                    <span class="breakdown-label">Total</span>
                    <span class="breakdown-value total-amount">{{ rent.total | currency }}</span>
                </div>
            </div>
        </div>

        <!-- #5 Desglose del Primer Pago -->
        <div class="payment-detail-card">
            <div class="payment-header">
                <i class="pi pi-credit-card text-green-600"></i>
                <h4>Primer Pago</h4>
                <p-tag *ngIf="term.downPayment?.isPaid || term.downPayment?.payed" value="Pagado" severity="success"></p-tag>
            </div>
            <div class="payment-breakdown">
                <div class="breakdown-row">
                    <span class="breakdown-label">Anticipo</span>
                    <span class="breakdown-value">{{ quote.advance?.amount | currency }}</span>
                </div>
                <div class="breakdown-row">
                    <span class="breakdown-label">Comisión por apertura</span>
                    <span class="breakdown-value">{{ quote.openingCommission?.amount | currency }}</span>
                </div>
                <div class="breakdown-row" *ngIf="term.advancedRents?.amount">
                    <span class="breakdown-label">Rentas anticipadas ({{ term.advancedRents.number }})</span>
                    <span class="breakdown-value">{{ term.advancedRents.amount | currency }}</span>
                </div>
                <!-- F-016: solo existe en cotizaciones que cobran la renta anticipada completa -->
                <div class="breakdown-row" *ngIf="term.advancedRents?.accessories > 0">
                    <span class="breakdown-label">Accesorios de rentas anticipadas</span>
                    <span class="breakdown-value">{{ term.advancedRents.accessories | currency }}</span>
                </div>
                <div class="breakdown-row" *ngIf="quote.ratificationExpenses">
                    <span class="breakdown-label">Gastos de ratificación</span>
                    <span class="breakdown-value">{{ quote.ratificationExpenses | currency }}</span>
                </div>
                <div class="breakdown-row" *ngIf="term.accessoriesDetail?.cash?.amount">
                    <span class="breakdown-label">Accesorios de contado</span>
                    <span class="breakdown-value">{{ term.accessoriesDetail.cash.amount | currency }}</span>
                </div>
                <div class="breakdown-separator"></div>
                <div class="breakdown-row">
                    <span class="breakdown-label">Subtotal</span>
                    <span class="breakdown-value">{{ term.downPayment.amount | currency }}</span>
                </div>
                <div class="breakdown-row">
                    <span class="breakdown-label">IVA</span>
                    <span class="breakdown-value">{{ term.downPayment.iva | currency }}</span>
                </div>
                <div class="breakdown-separator"></div>
                <div class="breakdown-row total-row">
                    <span class="breakdown-label">Total</span>
                    <span class="breakdown-value total-amount">{{ term.downPayment.total | currency }}</span>
                </div>
            </div>
        </div>

        <!-- #6 Desglose del Residual -->
        <div class="payment-detail-card">
            <div class="payment-header">
                <i class="pi pi-wallet text-purple-600"></i>
                <h4>Valor Residual ({{ (term.residuary.percentage * 100) | number: '1.2-2' }}%)</h4>
                <p-tag *ngIf="term.residuary?.isPaid || term.residuary?.payed" value="Pagado" severity="success"></p-tag>
            </div>
            <div class="payment-breakdown">
                <div class="breakdown-row">
                    <span class="breakdown-label">Monto</span>
                    <span class="breakdown-value">{{ term.residuary.amount | currency }}</span>
                </div>
                <div class="breakdown-row">
                    <span class="breakdown-label">IVA</span>
                    <span class="breakdown-value">{{ term.residuary.iva | currency }}</span>
                </div>
                <div class="breakdown-separator"></div>
                <div class="breakdown-row total-row">
                    <span class="breakdown-label">Total</span>
                    <span class="breakdown-value total-amount">{{ term.residuary.total | currency }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- #4 Valor de Accesorios desglosado -->
    <div class="accessories-section terms-breakdown-accessories"
        *ngIf="showAccessories !== false && term && (term.accessoriesDetail?.cash?.amount > 0 || term.accessoriesDetail?.financed?.total?.amount > 0)">
        <h4 class="section-subtitle">Accesorios</h4>
        <div class="accessories-list">
            <div class="accessory-item" *ngIf="term.accessoriesDetail?.cash?.amount > 0">
                <div class="accessory-header">
                    <span class="accessory-name">Accesorios de Contado</span>
                    <p-tag value="Contado" severity="success" class="payment-tag"></p-tag>
                </div>
                <div class="accessory-details">
                    <span class="detail-item">
                        <i class="pi pi-dollar text-green-600"></i>
                        {{ term.accessoriesDetail.cash.total | currency }}
                    </span>
                    <span class="detail-item" *ngIf="term.accessoriesDetail.cash.concepts">
                        <i class="pi pi-info-circle text-blue-600"></i>
                        {{ term.accessoriesDetail.cash.concepts }}
                    </span>
                </div>
            </div>
            <div class="accessory-item" *ngIf="term.accessoriesDetail?.financed?.total?.amount > 0">
                <div class="accessory-header">
                    <span class="accessory-name">Accesorios Financiados</span>
                    <p-tag value="Financiado" severity="info" class="payment-tag"></p-tag>
                </div>
                <div class="accessory-details">
                    <span class="detail-item">
                        <i class="pi pi-dollar text-green-600"></i>
                        {{ term.accessoriesDetail.financed.total.total | currency }}
                    </span>
                    <span class="detail-item">
                        <i class="pi pi-calendar text-blue-600"></i>
                        {{ term.accessoriesDetail.financed.period.total | currency }} / período
                    </span>
                    <span class="detail-item" *ngIf="term.accessoriesDetail.financed.total.concepts">
                        <i class="pi pi-info-circle text-blue-600"></i>
                        {{ term.accessoriesDetail.financed.total.concepts }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
